<template>
  <vs-popup class="add-new-company-holiday"
            id="popup"
            title="VIEW QC TEST"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateQcTest)" autocomplete="off">


          <div class="flex">
            <div class="flex">

            </div>
            <div class="flex justify-end ml-auto">
              <vs-chip class="text-center" transparent color="warning">
                Done by: {{ form.done_by }}
              </vs-chip>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">
                  Test Type
                </small>
                <v-select
                  :disabled="company_data.test_type"
                  :clearable="false" name="country" placeholder=""
                          label="name" v-model="form.test_type" :reduce="option => option.value"
                          :options="test_types" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

<!--        start  Odour_and_Appearance_Check-->
          <div class="vx-row mb-3" v-if="form.test_type === 'Odour_and_Appearance_Check'">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="o_a_check_odour" name="o_a_check_odour" rules="required" v-slot="{ errors }">
                <small class="label">
                  Odour <span v-if="company_data.odour" class="qc-test-guide-text">(Guide: {{ company_data.odour }})</span>
                </small>
                <vs-input v-model="form.o_a_check.odour"  name="o_a_check_odour" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3" v-if="form.test_type === 'Odour_and_Appearance_Check'">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="o_a_check_appearance" name="o_a_check_appearance" rules="required" v-slot="{ errors }">
                <small class="label">
                  Appearance <span v-if="company_data.appearance" class="qc-test-guide-text">(Guide: {{ company_data.appearance }})</span>
                </small>
                <vs-input v-model="form.o_a_check.appearance"  name="o_a_check_appearance" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
<!--          end Odour_and_Appearance_Check-->


<!--          start Taste_Odour_and_Appearance_Check-->
          <div class="vx-row mb-3" v-if="form.test_type === 'Taste_Odour_and_Appearance_Check'">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="t_o_a_check_taste" name="t_o_a_check_taste" rules="required" v-slot="{ errors }">
                <small class="label">
                  Taste <span v-if="company_data.taste" class="qc-test-guide-text">(Guide: {{ company_data.taste }})</span>
                </small>
                <vs-input v-model="form.t_o_a_check.taste"  name="t_o_a_check_taste" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3" v-if="form.test_type === 'Taste_Odour_and_Appearance_Check'">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="t_o_a_check_odour" name="t_o_a_check_odour" rules="required" v-slot="{ errors }">
                <small class="label">
                  Odour <span v-if="company_data.odour" class="qc-test-guide-text">(Guide: {{ company_data.odour }})</span>
                </small>
                <vs-input v-model="form.t_o_a_check.odour"  name="t_o_a_check_odour" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3" v-if="form.test_type === 'Taste_Odour_and_Appearance_Check'">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="t_o_a_check_appearance" name="t_o_a_check_appearance" rules="required" v-slot="{ errors }">
                <small class="label">
                  Appearance <span v-if="company_data.appearance" class="qc-test-guide-text">(Guide: {{ company_data.appearance }})</span>
                </small>
                <vs-input v-model="form.t_o_a_check.appearance"  name="t_o_a_check_appearance" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
<!--         end Taste_Odour_and_Appearance_Check-->

<!--          start Odour_Appearance_SG_and_RI_Check-->
          <div class="vx-row mb-3" v-if="form.test_type === 'Odour_Appearance_SG_and_RI_Check'">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="o_a_s_r_check_odour" name="o_a_s_r_check_odour" rules="required" v-slot="{ errors }">
                <small class="label">
                  Odour <span v-if="company_data.odour" class="qc-test-guide-text">(Guide: {{ company_data.odour }})</span>
                </small>
                <vs-input v-model="form.o_a_s_r_check.odour"  name="o_a_s_r_check_odour" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3" v-if="form.test_type === 'Odour_Appearance_SG_and_RI_Check'">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="o_a_s_r_check_appearance" name="o_a_s_r_check_appearance" rules="required" v-slot="{ errors }">
                <small class="label">
                  Appearance <span v-if="company_data.appearance" class="qc-test-guide-text">(Guide: {{ company_data.appearance }})</span>
                </small>
                <vs-input v-model="form.o_a_s_r_check.appearance"  name="o_a_s_r_check_appearance" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3" v-if="form.test_type === 'Odour_Appearance_SG_and_RI_Check'">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="s_g" name="s_g" rules="required" v-slot="{ errors }">
                <small class="label">
                  SG  <span v-if="company_data.sg_from && company_data.sg_to" class="qc-test-guide-text">(Guide: {{ company_data.sg_from }} - {{ company_data.sg_to }})</span>
                </small>
                <vs-input v-model="form.o_a_s_r_check.s_g"  name="s_g" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="r_i" name="r_i" rules="required" v-slot="{ errors }">
                <small class="label">
                  RI <span v-if="company_data.ri_from && company_data.ri_to" class="qc-test-guide-text">(Guide: {{ company_data.ri_from }} - {{ company_data.ri_to }})</span>
                </small>
                <vs-input v-model="form.o_a_s_r_check.r_i"  name="r_i" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

<!--          end Odour_Appearance_SG_and_RI_Check-->

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="q_c_status" name="q_c_status" rules="required" v-slot="{ errors }">
                <small class="label">Status</small>
                <v-select disabled :clearable="true" name="q_c_status" placeholder="" v-model="form.q_c_status"
                          :options="['Approved', 'Rejected']" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

<!--          <vs-alert v-if="form.q_c_status === 'Approved'" class="mt-2 mb-8" icon-pack="feather" icon="icon-info" color="warning" active="true">-->
<!--            The Item Quantity will be added to stock-->
<!--          </vs-alert>-->

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="quantity" name="quantity" rules="" v-slot="{ errors }">
                <small class="label">Quantity (KG)</small>
                <vs-input disabled type="number" step="0.0001" v-model="form.quantity"   name="quantity" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="notes" name="notes" rules="" v-slot="{ errors }">
                <small class="label">Notes</small>
                <vs-textarea disabled class="mb-0" v-model="form.notes" height="150px"/>
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <!-- <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="form = {}" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div> -->
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'

  const InventoryRepository = RepositoryFactory.get('inventory');
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')

  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from "vue-select";

  function initialState() {
    return {
      open: false,
      id: '',
      form: {
        test_type:'',
        o_a_check: {
          odour: '',
          appearance: ''
        },
        t_o_a_check: {
          taste: '',
          odour: '',
          appearance: ''
        },
        o_a_s_r_check: {
          odour: '',
          appearance: '',
          s_g: '',
          r_i: '',
        },
        notes: '',
        q_c_status: '',
        quantity: '',
      },
      isCreateMode: true,
      test_types: [
        {name: 'Do Not Sample', value: 'Do_Not_Sample'},
        {name: 'Odour and Appearance Check', value: 'Odour_and_Appearance_Check'},
        {name: 'Taste Odour and Appearance Check', value: 'Taste_Odour_and_Appearance_Check'},
        {name: 'Odour Appearance SG and RI Check', value: 'Odour_Appearance_SG_and_RI_Check'}
      ],
      company_data: {}
    }
  }

  export default {
    name: 'AddQcTestRmOrderItemPopUp',
    data() {
      return initialState()
    },
    methods: {
      async openPopup(id, raw_material_id) {
        try {
          Object.assign(this.$data, initialState());
          this.$refs.form.reset();
          this.open = true;
          this.id = id
          this.raw_material_id = raw_material_id
          await this.getQcTestDetails()
          await this.fetchRmCompanyData()
        } catch (error) {

        }
      },
      async fetchRmCompanyData() {
        this.$vs.loading();
        try {
          const {data} = (await SupplierRawMaterialRepository.getRawMaterialCompanyData(this.raw_material_id)).data
          this.company_data = data
          // //o_a_check
          // this.form.o_a_check.odour = this.company_data.odour
          // this.form.o_a_check.appearance = this.company_data.appearance
          // //t_o_a_check
          // this.form.t_o_a_check.taste = this.company_data.taste
          // this.form.t_o_a_check.odour = this.company_data.odour
          // this.form.t_o_a_check.appearance = this.company_data.appearance
          // //o_a_s_r_check
          // this.form.o_a_s_r_check.odour = this.company_data.odour
          // this.form.o_a_s_r_check.appearance = this.company_data.appearance
          // this.form.o_a_s_r_check.taste = this.company_data.taste
          // this.form.o_a_s_r_check.s_g_from = this.company_data.sg_from
          // this.form.o_a_s_r_check.s_g_to = this.company_data.sg_to
          // this.form.o_a_s_r_check.r_i_from = this.company_data.ri_from
          // this.form.o_a_s_r_check.r_i_to = this.company_data.ri_to

        } catch (e) {

        }
        this.$vs.loading.close()
      },
      async getQcTestDetails() {
        this.$vs.loading();
        try {
          const {data} = (await InventoryRepository.getOrderItemQcTest(this.id)).data
          this.form = data
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onClickCreateQcTest() {
        const vue = this;
        this.$vs.loading();
        try {
          await InventoryRepository.updateOrderItemQcTest(this.id, this.form);
          this.showSuccessMessage('Item QC Test updated!');
          await vue.$parent.refreshData();
          this.open = false;
        } catch (e) {
          this.$vs.loading.close();
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
    },
    components: {
      flatPickr,
      'v-select': vSelect,
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .add-new-company-holiday >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 30% !important;
  }
  .qc-test-guide-text {
    color: coral;
    font-weight: bold ;
    margin-left: 5px;
  }

</style>
